import { sendFetch, POST_OPTIONS, GET_OPTIONS } from './base.service';

const BASE_PATH = '/process_state';

export const findPorcessState = async (company) => {
    return await sendFetch(`${BASE_PATH}/all/company/${company}`, GET_OPTIONS);
}